module.exports = __webpack_public_path__ + "media/fun/fun-1-df446cc4.jpg";